import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { media } from '@clds/style-utils';
import { StickyPageHeader } from '../../components/StickyPageHeader/StickyPageHeader';

export const PageWrapper = styled.div`
  ${StickyPageHeader} {
    display: none;
    border-bottom: none;
  }

  @media ${media.tablet({ maxOnly: true })} {
    ${StickyPageHeader} {
      display: block;
    }
  }
`;

export const TitleWrapper = styled.div`
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ContentHeader = styled.div`
  ${typography.xl.regular};
  margin: 0 0 ${globalTheme.spacing.md};
`;

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const PageContainer = styled.div`
  background: ${globalTheme.palette.background};
  margin: ${globalTheme.spacing.xl} 0;
  padding: 0 ${globalTheme.spacing.sm};
`;

export const ContentWrapper = styled.div`
  width: 900px;
  max-width: 100%;
  margin: 0 auto;
`;

export const ContentInner = styled.div`
  background: ${globalTheme.palette.surface};
  border-radius: ${globalTheme.radius.lg};
  padding: ${globalTheme.spacing.xl};
`;

export const Footer = styled.div`
  margin-top: ${globalTheme.spacing.lg};
`;
